import { type } from "@testing-library/user-event/dist/type";
import * as actionTypes from "../../actionLabels/generateSellerTaxInvoice/generateSellerTaxInvoiceActionlabels";

export const sellertoauctioneerinvoice_search = (payload) => {
  return {
    type: actionTypes.SELLERTOAUCTIONEERINVOICE_SEARCH,
    payload: payload,
  };
};

export const sellertoauctioneerinvoice_search_Success = (data) => {
  return {
    type: actionTypes.SELLERTOAUCTIONEERINVOICE_SEARCH_SUCCESS,
    payload: data,
  };
};

export const sellertoauctioneerinvoice_search_Fail = (error) => {
  return {
    type: actionTypes.SELLERTOAUCTIONEERINVOICE_SEARCH_FAIL,
    payload: error,
  };
};

export const viewinvoicedetail = (payload) => {
  console.log(payload,"payload_action")
  return {
    type: actionTypes.SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL,
    payload: payload,
  };
};

export const viewinvoicedetail_Success = (data) => {
  console.log(data,"payload_action_suss")
  return {
    type: actionTypes.SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL_SUCCESS,
    payload: data,
  };
};

export const viewinvoicedetail_Fail = (error) => {
  return {
    type: actionTypes.SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL_FAIL,
    payload: error,
  };
};

export const sellertoauctioneerinvoice_create = (payload) => {
  return {
    type: actionTypes.SELLERTOAUCTIONEERINVOICE_CREATE,
    payload: payload,
  };
};

export const sellertoauctioneerinvoice_create_Success = (data) => {
  return {
    type: actionTypes.SELLERTOAUCTIONEERINVOICE_CREATE_SUCCESS,
    payload: data,
  };
};

export const sellertoauctioneerinvoice_create_Fail = (error) => {
  return {
    type: actionTypes.SELLERTOAUCTIONEERINVOICE_CREATE_FAIL,
    payload: error,
  };
};


export const sellertoauctioneerApiStutas = (data) => {
  return {
    type: actionTypes.API_STATUS_SELLER_TAX,
    payload: { data: data },
  };
};


export const enableGenerateInvoiceButton = () => ({
  type: actionTypes.ENABLE_GENERATE_INVOICE_BUTTON
});



export const disableGenerateInvoiceButton = () => {
  return {
    type: actionTypes.DISABLE_GENERATE_INVOICE_BUTTON,
  };
};

export const enableSearchInvoiceButton = ()=>({
  type: actionTypes.ENABLE_SEARCH_INVOICE_BUTTON,
});

export const disableSearchInvoiceButton = ()=>({
  type: actionTypes.DISABLE_SEARCH_INVOICE_BUTTON,
})


